import { ScheduleEntryState, Task, Timestamp } from '@griply/types';
import { isSameDay } from 'date-fns';

import { isHabitOrRepeatingTask } from './is-habit-or-repeating-task';
import { getActiveSchedule } from './schedules';

export const isHabitCompletedOnDay = (task: Task, day: Timestamp): boolean => {
  if (!isHabitOrRepeatingTask(task)) {
    return false;
  }

  const activeSchedule = getActiveSchedule(task.schedules, day);
  if (!activeSchedule) {
    return false;
  }

  return !!activeSchedule.entries.find(
    (entry) =>
      entry.state === ScheduleEntryState.Complete &&
      !!entry.value &&
      isSameDay(entry.date, day),
  );
};
